<template>
  <div>
    <div class="step-title">通过手机号找回</div>

    <a-form-model ref="formRef" :model="form" :rules="rules" layout="vertical">
      <a-form-model-item prop="mobile">
        <a-input v-model="form.mobile" size="large" placeholder="请输入手机号">
          <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input>
      </a-form-model-item>

      <a-row :gutter="15" class="captcha-row">
        <a-col :span="15">
          <a-form-model-item prop="captcha">
            <a-input v-model="form.captcha" size="large" placeholder="请输入验证码">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="9">
          <a-button
            class="get-captcha"
            size="large"
            :disabled="state.smsSendBtn || state.captchaLoading"
            :loading="state.captchaLoading"
            @click.prevent="$emit('get-captcha')"
          >
            {{ !state.smsSendBtn ? "获取验证码" : `${state.time}秒后重发` }}
          </a-button>
        </a-col>
      </a-row>

      <div
        id="captcha-forget"
        :class="captchaConfig.config.product === 'bind' ? 'hide-height' : ''"
      >
        <AliCaptcha :captcha-config="captchaConfig" />
      </div>

      <div v-if="state.showCaptchaMsg" class="captcha-tip-wrap">
        <p class="captcha-tip">
        <a-icon
          :type="tipIconType"
          :style="{ color: tipIconColor, marginRight: '6px' }"
        />
        <span>{{ showCaptchaMsg }}</span>
        </p>
      </div>

      <a-form-model-item class="submit-item">
        <a-button
          type="primary"
          size="large"
          block
          :loading="submitLoading"
          :disabled="submitLoading"
          @click="handleNext"
        >
          下一步
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import AliCaptcha from "@/components/AliCaptcha.vue";

export default {
  components: {
    AliCaptcha,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    rules: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
      required: true,
    },
    captchaConfig: {
      type: Object,
      required: true,
    },
    showCaptchaMsg: {
      type: String,
      default: "",
    },
    tipIconType: {
      type: String,
      default: "check-circle",
    },
    tipIconColor: {
      type: String,
      default: "#52c41a",
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleNext() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("next");
        }
      });
    },
    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
    },
  },
};
</script>

<style scoped>
.step-title {
  margin-bottom: 28px;
  font-size: 18px;
  text-align: center;
  color: #333;
}

.get-captcha {
  display: block;
  width: 100%;
  height: 50px;
  border-radius: 4px;
  font-weight: 500;
}

.captcha-tip-wrap {
  clear: both;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 18px;
}

.captcha-tip {
  display: flex;
  align-items: center;
  margin: 0;
  color: #666;
  font-size: 13px;
  line-height: 1.4;
}

.submit-item {
  margin-top: 8px;
  margin-bottom: 0;
}

.captcha-row /deep/ .ant-form-item {
  margin-bottom: 0;
}

.hide-height {
  height: 0;
  overflow: hidden;
}
</style>
